import moment from 'moment';

import Logger from 'utils/Logger';

import { DAY_OPTIONS, TIME_SLOT_FORMAT } from '../constants';

const currentYear = moment().year();
const currentMonth = moment().month() + 1;

interface UpdateDayOptionsArguments {
  selectedYear?: string;
  selectedMonth?: string;
  savedYear?: string | null;
  savedMonth?: string | null;
}

/* Helper function to update valid day options based on selected year and month */
export const updateDayOptions = (
  {
    selectedYear,
    selectedMonth,
    savedYear,
    savedMonth,
  }: UpdateDayOptionsArguments,
) => {
  const yearToUse = selectedYear || savedYear || currentYear;
  const monthToUse = selectedMonth || savedMonth || currentMonth;

  const filteredDayOptions = DAY_OPTIONS.filter((option) => {
    const day = option.id;
    const date = moment(`${yearToUse}-${monthToUse}-${day}`, 'YYYY-M-D');
    return date.isValid();
  });

  return filteredDayOptions;
};

export const formatTimeSlot = (date: string, time: string) =>
  moment.utc(date)
    .add(time, 'minutes')
    .format(TIME_SLOT_FORMAT);

export const formatBirthDate = ({ year, month, day }: { year: string, month: string, day: string }) => {
  const yearInt = parseInt(year);
  const monthInt = parseInt(month);
  const dayInt = parseInt(day);

  if (!yearInt || !monthInt || !dayInt) {
    Logger.error('Invalid birth date', { year, month, day });
    return null;
  }

  const date = moment({
    year: yearInt,
    month: monthInt - 1,
    date: dayInt,
  });

  if (!date.isValid()) {
    Logger.error('Invalid birth date', { year, month, day });
    return null;
  }

  return date.format('YYYY-MM-DD');
};